export enum DiscountType {
  Promo = 'promo',
  Prime = 'prime',
  Default = 'default',
}

export interface IDiscount {
  discount: number | null
}
